import { selectorActiveNotifications } from "./selectorActiveNotifications";

import {
  NotificationHandleType,
  WSNotificationResponse
} from "../components/Notifications";

export const selectorW9ConsentNotifications = (
  responses: WSNotificationResponse[]
) => {
  return selectorActiveNotifications(responses).filter(response => {
    return response.handle === NotificationHandleType.W9Consent;
  });
};
